/**
 * This function isn't much use on its own however via JSDoc it exposes the correct airity
 * of a returned createSelector function for typescript consumers.
 *
 * @param {any} state - The full redux store
 * @param {any} props - react component props
 */
export const forwardProps = (state: any, props: Record<string, unknown>) =>
  props;
